module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjgiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0IDgiPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTS4xNDQgNC4zOTZsMy4wMTcgMy40NGEuNDUuNDUgMCAwIDAgLjY5NSAwIC42MTcuNjE3IDAgMCAwIDAtLjc5MkwxLjE4NiA0IDMuODU2Ljk1NmEuNjE3LjYxNyAwIDAgMCAwLS43OTIuNDUuNDUgMCAwIDAtLjY5NSAwTC4xNDQgMy42MDRBLjYuNiAwIDAgMCAwIDRhLjYuNiAwIDAgMCAuMTQ0LjM5NnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = tqch
// module chunks = 22